export default __webpack_public_path__ + "static/media/ceo-slide1.c6def10b.jpg";